import React from 'react';
import { useStrapi } from '../hooks/useStrapi';
import { getPageBySlug } from '../services/strapi';

const FALLBACK = {
  heroTitle: 'Om Sikker SMV',
  heroSubtitle: 'Din partner inden for IT-sikkerhed og compliance',
  content: `## Vores mission

Sikker SMV blev grundlagt med en klar mission: at gøre IT-sikkerhed og compliance tilgængeligt for alle danske virksomheder – uanset størrelse.

## Hvad vi tilbyder

Vi kombinerer ekspertviden med brugervenlige platforme, så din virksomhed kan fokusere på det, I er bedst til, mens vi tager os af sikkerheden.

## Vores tilgang

Vi tror på at IT-sikkerhed ikke behøver at være kompliceret eller dyrt. Med de rette værktøjer og processer kan enhver virksomhed opnå et højt sikkerhedsniveau.`,
};

export default function AboutPage() {
  const { data } = useStrapi(() => getPageBySlug('om-os'));
  // useStrapi already unwraps result.data, so data is the array directly
  const page = data?.[0]?.attributes || FALLBACK;

  // Simple markdown-to-HTML for ## headings and paragraphs
  const renderContent = (content) => {
    if (!content) return null;
    return content.split('\n\n').map((block, i) => {
      if (block.startsWith('## ')) {
        return <h2 key={i}>{block.replace('## ', '')}</h2>;
      }
      return <p key={i}>{block}</p>;
    });
  };

  return (
    <>
      <section className="hero" style={{ padding: '3rem 0' }}>
        <div className="container">
          <h1 className="hero__title" style={{ fontSize: '2.2rem' }}>{page.heroTitle}</h1>
          <p className="hero__subtitle">{page.heroSubtitle}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="page-content">
            {renderContent(page.content)}
          </div>
        </div>
      </section>
    </>
  );
}
